import React from "react";
import i18n from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import EnglishLanguage from "./locales/en/translate.json";
import ArabicLanguage from "./locales/ar/translate.json";
import ChineseLanguage from "./locales/ch/translate.json";
import { cookieService } from "./services/CookieService";
import EventEmitter, { Events } from "./services/eventemitter";

import { utils } from './utils';
const language = utils.isArabicLanguage() ? "ar" : utils.isChineseLanguage() ? "ch" : "en"
let lang = cookieService.getElectronCookies('language');
                 


class Data{
  constructor(){
    EventEmitter.on(Events.setWebContentLang, this.setWebContentLang);
  }
  setWebContentLang = (value: any) => {
    lang = value
    i18n.changeLanguage(value)
    EventEmitter.emit(Events.forceFullyChangeLanguage, value);
  } 
}

const d1 = new Data();

i18n
  //   .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: EnglishLanguage,
      ar: ArabicLanguage,
      ch: ChineseLanguage
    },

    lng: lang, // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
    // lng: lang,
    // fallbackLng: lang,
    // debug: true,
    // ns: ["translations"],
    // defaultNS: "translations",
    // keySeparator: ".",
    // interpolation: {
    //   escapeValue: false,
    //   formatSeparator: ",",
    // },
    // react: {
    //   wait: true,
    //   bindI18n: "languageChanged loaded",
    //   bindI18nStore: "added removed",
    //   nsMode: "default",
    // },
  });
export default i18n;
